var render = function render(){var _vm=this,_c=_vm._self._c;return _c('memlist-card',{staticClass:"login-body mb-5"},[(!_vm.error)?_c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('SCANQR.REDIRECTING')))])]):_c('div',[(_vm.error == 'NO_TOKEN')?_c('p',[_vm._v(_vm._s(_vm.$t('SCANQR.NO_TOKEN')))]):_vm._e(),(_vm.error == 'NO_MEMBER')?_c('p',[_vm._v(_vm._s(_vm.$t('SCANQR.NO_MEMBER')))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }